import { Component, OnInit } from '@angular/core';
import { HttpModule } from '@angular/http';
import { Validators, FormGroup, FormBuilder } from '@angular/forms';
import { Router } from '@angular/router';
import { FlashMessagesService } from 'angular2-flash-messages';

// Services
import { ProductInsertService } from '../../service/product-insert/product-insert.service';

@Component({
	selector: 'app-product-insert',
	templateUrl: './product-insert.component.html',
	providers: [
		ProductInsertService,
		HttpModule
	]
})
export class ProductInsertComponent implements OnInit {

	private token;

	product: FormGroup;
	Nome: string = "";
	statusProduct: boolean;
	public permissoes: any[] = [];

	constructor(fb: FormBuilder, private productInsertService: ProductInsertService, private flashMessagesService: FlashMessagesService, private router: Router) {
		this.token = localStorage.getItem('yara.token');
		this.product = fb.group({
			'Nome': [null, Validators.compose([Validators.required, Validators.maxLength(120)])],
			'Ativo': ''
		});
	}

	ngOnInit() {
		this.permissoes = localStorage.getItem('yara.permissions') ? JSON.parse(localStorage.getItem('yara.permissions')) : [];
	}

	addProduct(value: any) {
		console.log(value);
		this.productInsertService.insertProduct(this.token, value).subscribe(result => {
			if (result.Success) {
				this.flashMessagesService.show('Produtos e Serviços editado com sucesso', { cssClass: 'alert-success', timeout: 6000 });
				this.router.navigateByUrl('/produto-servico');
			} else {
				this.flashMessagesService.show(result.Errors, { cssClass: 'alert-danger', timeout: 6000 });
			}
		}, error => {
			console.log(error);
			
		});
	}

	cancelInsertEdit() {
		this.router.navigateByUrl('/produto-servico');
	}

}



// WEBPACK FOOTER //
// ./src/app/product/component/product-insert/product-insert.component.ts